<ndt-presence-contact-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   [columns]="columns"
   [presenceContactPrivileges]="presenceContactPrivileges$ | async"
   [editPresenceContactPrivileges]="editPresenceContactPrivileges$ | async"
   [currentUser]="currentUser$ | async"
   (openDialog)="onOpenDialog($event)"
   (initiateDirectedCall)="onInitiateDirectedCall($event)"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
   (edit)="onEdit($event)"
></ndt-presence-contact-register-view>
